import { isDifferentCalendarDay } from '@/utils/chatDateTime';
import type { ChatAIFormMessage } from './ChatAIFormMessage';

export type ChatFeedItem =
    { kind: 'day'; key: string; sentAt: string } | { kind: 'message'; key: string; message: ChatAIFormMessage };

/**
 * Лента с разделителем дня перед первым сообщением каждого календарного дня. Так помечается и «оживание» старого
 * треда: между старыми сообщениями и новым появляется разделитель с новой датой. Сообщение без даты разделителя не
 * получает, а следующее за ним с датой — получает.
 *
 * Ключ — место сообщения в ленте, а не id: после ответа история приходит с сервера, и временный id вопроса
 * сменяется серверным; с ключом по id все сообщения и их аватары перемонтировались бы.
 */
export function withDaySeparators(messages: ChatAIFormMessage[]): ChatFeedItem[] {
    return messages.flatMap((message, i): ChatFeedItem[] => {
        const item: ChatFeedItem = { kind: 'message', key: `${message.direction}-${i}`, message };
        const prev = messages[i - 1];
        if (!message.sentAt || (prev?.sentAt && !isDifferentCalendarDay(prev.sentAt, message.sentAt))) return [item];
        return [{ kind: 'day', key: `day-${i}`, sentAt: message.sentAt }, item];
    });
}
